import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingCart, LogOut, User as UserIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import CartModal from './CartModal'; // Importa el modal del carrito
import { useCart } from './CartContext'; // Importa el hook del carrito

const navItems = [
  { name: 'Dashboard', icon: LayoutDashboard, path: '/' },
  { name: 'Stock', icon: Package, path: '/stock' },
  { name: 'Pedidos', icon: ShoppingCart, path: '/orders' },
  { name: 'Mi Perfil', icon: UserIcon, path: '/profile' },
];

const Navbar = ({ onLogout, userName }) => {
  const navigate = useNavigate();
  const [isCartOpen, setIsCartOpen] = useState(false); // Estado para controlar el modal del carrito
  const { getTotalItems } = useCart(); // Obtiene el número total de ítems en el carrito

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <>
      <motion.nav
        className="bg-white/90 backdrop-blur-xl border-b border-gray-200/50 p-4 shadow-sm"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ type: "spring", stiffness: 120, damping: 14 }}
      >
        <div className="container mx-auto flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2 text-2xl font-bold text-gray-800">
            <motion.div
              initial={{ rotate: 0 }}
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            >
              <Package className="w-8 h-8 text-purple-600" />
            </motion.div>
            Massi Store
          </Link>
          <div className="flex items-center gap-6">
            {navItems.map((item, index) => (
              <Link key={item.name} to={item.path}>
                <motion.div
                  className="flex items-center gap-2 text-gray-600 hover:text-purple-600 transition-colors duration-200"
                  whileHover={{ scale: 1.05, color: '#9333ea' }}
                  whileTap={{ scale: 0.95 }}
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 + 0.2 }}
                >
                  <item.icon className="w-5 h-5" />
                  <span className="font-medium hidden md:block">{item.name}</span>
                </motion.div>
              </Link>
            ))}
            {userName && (
              <motion.div
                className="flex items-center gap-2 text-gray-700 font-semibold px-3 py-1 bg-gray-100 rounded-full"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.5 }}
              >
                <UserIcon className="w-5 h-5 text-blue-500" />
                <span>Hola, {userName}</span>
              </motion.div>
            )}
            {/* Botón del carrito de compras */}
            <motion.button
              onClick={() => setIsCartOpen(true)}
              className="relative flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg font-semibold shadow-md hover:bg-blue-600 transition-colors duration-200"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <ShoppingCart className="w-5 h-5" />
              <span className="hidden md:block">Carrito</span>
              {getTotalItems() > 0 && (
                <motion.span
                  className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center"
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ type: "spring", stiffness: 500, damping: 30 }}
                >
                  {getTotalItems()}
                </motion.span>
              )}
            </motion.button>
            <motion.button
              onClick={handleLogout}
              className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white rounded-lg font-semibold shadow-md hover:bg-red-600 transition-colors duration-200"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <LogOut className="w-5 h-5" />
              <span className="hidden md:block">Salir</span>
            </motion.button>
          </div>
        </div>
      </motion.nav>
      <CartModal isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
};

export default Navbar;